import { Box, Typography } from '@mui/material';
import React from 'react';
import { SxProps } from '@mui/material/styles';

const bulletPointStyling: SxProps = {
  mt: 1,
  display: 'flex', // Align bullet and text in a flex container
  alignItems: 'flex-start', // Align items at the top
  lineHeight: 1.5, // Maintain proper text spacing
  pl: 1, // Adjust padding for spacing
  position: 'relative',
  '&::before': {
    content: '""', // Create a custom bullet point
    position: 'absolute',
    left: -10, // Adjust position relative to text
    top: '0.75em', // Position bullet at the first line of text
    width: 3, // Set bullet size
    height: 3, // Set bullet size
    backgroundColor: 'currentColor', // Matches text color
    borderRadius: '50%', // Makes it a small circle
    transform: 'translateY(-50%)' // Slight vertical adjustment
  }
};

const container: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  gap: 1
};

type Props = {
  label: string;
  value?: string | string[];
};

export const SummaryField: React.FC<Props> = ({ label, value }) => {
  if (!value || (Array.isArray(value) && !value.length)) {
    return null;
  }

  return (
    <Box sx={container}>
      <Typography variant="body1" fontWeight="bold">
        {label}
      </Typography>
      {Array.isArray(value) ? (
        <Box component="ul" sx={{ pl: 4, m: 0 }}>
          {value.map((item, index) => (
            <Typography key={index} component="li" sx={bulletPointStyling}>
              {item.split('\n').map((line, i) => (
                <React.Fragment key={i}>
                  {line}
                  {i < item.split('\n').length - 1 && <br />}
                </React.Fragment>
              ))}
            </Typography>
          ))}
        </Box>
      ) : (
        <Typography>{value}</Typography>
      )}
    </Box>
  );
};
